import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DISPLAY_STATUS, STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { IModule } from 'src/app/interfaces/resource';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { GrammarInUseStore } from 'src/app/stores/resources/grammarInUse';

@Component({
  selector: 'app-grammar-in-use',
  templateUrl: './grammar-in-use.component.html',
  styleUrls: ['./grammar-in-use.component.scss']
})
export class GrammarInUseComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  displayStatus = DISPLAY_STATUS
  tabs = TABS.GRAMMAR_IN_USE;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: GrammarInUseStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private ds:DataService,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      this.store.fetchGrammarInUse(false)
    })
  }

  showActivity(item: IModule) {
    this.router.navigate([`/grammar-in-use/lesson/${item.key}`])
  }

  create() {
    this.router.navigate([`/grammar-in-use/grammar-in-use-lesson/draft`])
  }

  delete(item) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: item.name, title: 'Delete Module' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      // if (result === 'yes') {
      //   this.store.deleteModule(COLLECTION_NAME.MODULE, COLLECTION_NAME.ACTIVITY, item, (success, res) => {
      //     this.snackBar.open("Module has been deleted successful.", "Done", { duration: 1000 });

      //     const { selectedCompanyKey } = this.auth;
      //     this.store.fetchData(COLLECTION_NAME.MODULE, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey)
      //   })
      // }
    })
  }

}
